import type { Route } from "@angular/router";
import { GEOPORTAL_PROVIDERS } from "./features/geoportal/geoportal-providers";

export const appRoutes: Route[] = [
  // ── Ruta raíz: Geoportal de presentación (cards de aplicaciones) ──
  {
    path: "",
    providers: [...GEOPORTAL_PROVIDERS],
    loadComponent: () =>
      import("./features/geoportal/views/geoportal-view").then(
        (m) => m.GeoportalView,
      ),
  },
  // ── Login: vista auth (LoginFormComponent con branding GisHub) ──
  {
    path: "login",
    loadComponent: () =>
      import("./features/auth/views/login-view/login-view").then(
        (m) => m.LoginView,
      ),
  },
];
